import auth0 from 'auth0-js'
import { defined } from '@src/utils/defined'

const auth = new auth0.WebAuth({
  // https://auth0.com/docs/libraries/auth0js/v9#available-parameters
  domain: defined(process.env.AUTH0_DOMAIN),
  clientID: defined(process.env.AUTH0_CLIENT_ID),
  redirectUri: window.location.origin,
  responseType: 'token id_token',
  scope: 'openid profile email',
})

export default window.Cypress
  ? {
      authorize() {
        console.info('auth.authorize')
      },
      parseHash({ hash }, callback) {
        console.info('auth.parseHash')
        if (hash.includes('state=forceValid')) {
          callback(
            null,
            hash
              .replace(/^\W/g, '')
              .split('&')
              .map((param) => {
                const [key, value] = param.split('=')
                const camelCasedKey = key.replace(/_(\w)/g, (match, letter) =>
                  letter.toUpperCase()
                )
                return { [camelCasedKey]: value }
              })
              .reduce((a, b) => ({ ...a, ...b }), {})
          )
        } else {
          auth.parseHash(...arguments)
        }
      },
      client: {
        userInfo(accessToken, callback) {
          console.info('auth.client.userInfo')
          const store = require('@state/store').default
          callback(null, store.state.auth.currentUser)
        },
      },
    }
  : auth
